import { SET_FRAMES } from './../const';

export default (frames) => {
  return {
    type: SET_FRAMES,
    frames: frames
  }
};
